import React from "react";
import { Form, Grid } from "semantic-ui-react";
import { useExtLabels } from '../../common/extLabels'

const Experience = ({ model, errors = {}, onChange, disabled }) => {
    const l = useExtLabels()

    const handleChange = target => onChange({ ...model, [target.name]: target.value });

    return (
        <React.Fragment>
            <h3>Dane dotyczące zgłaszanej osoby</h3>
            <Form.Input
                disabled={disabled}
                label={l("Rok urodzenia")}
                width={5}
                name="birthYear"
                value={model.birthYear}
                onChange={({ target }) => handleChange(target)}
                required
                pattern="^\d{4}$"
                error={!!errors.birthYear}
            />
            <Grid columns={3} divided verticalAlign="bottom">
                <Grid.Row stretched>
                    <Grid.Column>
                        <Form.Input
                            disabled={disabled}
                            label={l("Liczba lat doświadczenia w branży e-commerce")}
                            name="experience"
                            value={model.experience}
                            onChange={({ target }) => handleChange(target)}
                            required
                            pattern="^\d{1,2}$"
                            error={!!errors.experience}
                        />
                    </Grid.Column>
                    <Grid.Column>
                        <Form.Input
                            disabled={disabled}
                            label={l("Liczba lat na stanowisku Dyrektor e-commerce")}
                            name="ecommerceDirectorExperience"
                            value={model.ecommerceDirectorExperience}
                            onChange={({ target }) => handleChange(target)}
                            required
                            pattern="^\d{1,2}$"
                            error={!!errors.ecommerceDirectorExperience}
                        />
                    </Grid.Column>
                    <Grid.Column>
                        <Form.Input
                            disabled={disabled}
                            label={l("Czas pracy w aktualnym miejscu zatrudnienia")}
                            name="yearsInCurrentCompany"
                            value={model.yearsInCurrentCompany}
                            onChange={({ target }) => handleChange(target)}
                            required
                            pattern="^\d{1,2}$"
                            error={!!errors.yearsInCurrentCompany}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </React.Fragment>
    );
};

export default Experience;
